<template>
  <div class="ConfirmationView">
    <ApplicationBanner content="<h3>
                  <center>    <p><center>بِسْمِ اللهِ الرَّحْمٰنِ الرَّحِيْمِ     فَإِنَّ مَعَ الْعُسْرِ يُسْرًا</center></p>
      <p>“In the name of God, the Most Gracious, the Most Merciful”</p>
        <p>“verily, with hardship comes ease” [Quran 94:5]</p></center></h3>" />
    <b-container class="ConfirmationContent">
      <b-row>
        <b-col>
          <b-alert class="mt-5" variant="success" show>
            <p>Your application has been successfully submitted for review.</p>
            <p>Your application ID is: <b>{{applicationId}}</b></p>
          </b-alert>

          <h3 class="mt-5">What&rsquo;s next&hellip;</h3>

          <div class="detail mt-5">
            <div
              class="detail-icon detail-icon--envelope"
              :style="'background-image: url(' + require('../components/customIcon/_png/envelope.png') + ')'"
            ></div>

            <div class="detail-body">
              <h4>We’ve sent a copy of your application and your application reference number to <strong>{{emailAddress}}</strong></h4>
            </div>
          </div>

          <div class="detail mt-5">
            <div
              class="detail-icon detail-icon--survey"
              :style="'background-image: url(' + require('../components/customIcon/_png/survey.png') + ')'"
            ></div>

            <div class="detail-body">
              <h4>
                <strong>Please Note:</strong>
              </h4>              
              <ul class="mt-3">
                <li>
                  Applying with Building Blocks is not a guarantee that we can help you financially, or that your application will be approved.
                </li>
                <li>
                  Building Blocks is funded only by donations and supported by a small workforce. We most often cannot help you with all of your financial need.
                </li>
                <li>
                  Your bills and expenses remain in your name and are still your responsibility.
                </li>
                <li>
                  We will review your application within 2-3 business days and let you know if you are approved or denied, or if further information is needed to process your application.
                </li>
                <li>
                  We do not pay cash or checks to applicants. If you are approved and sign an acknowledgement letter, a one-time payment will be made directly to your landlord or utility company for only the approved amount for your application.
                </li>
              </ul>                               
            </div>
          </div>          
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ApplicationBanner from '@/components/application/ApplicationBanner.vue'

export default {
  name: 'ConfirmationView',
  components: {
    ApplicationBanner
  },
  computed: {   
    applicationId() {
      try {
        return this.$store.state.submittedApplicationId || ''
      } catch (e) {
        return ''
      }
    }, 
    emailAddress() {
      try {
        return this.$store.state.application.client.email || 'your email address'
      } catch (e) {
        return 'your email address'
      }
    }
  },
  filters: {
    capitalise: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss">
#app {
  .ConfirmationView {
    margin: 0;
    padding: 0 0 40px;
    .ApplicationBanner {
      height: 130px;
      padding: 0px 15px;
      .container {
        .bannerTitle {
          position: absolute;
          transform: none;
          bottom: 10px;
          top: auto;
        }
      }
    }
    .ConfirmationContent {
      margin-top: 80px;
    }  

    h4 {
      font-weight: normal;
      font-size: 2rem;
    }

    p,
    li {
      font-size: 1.4rem;
    }

    p {
      margin-bottom: 0;
    }

    ul {
      > li + li {
        margin-top: $content-padding;
      }
    }

    .alert {
      padding: 1rem;
      border: 1px solid;
      border-radius: 0.2rem;
      color: #212529;
    }

    .alert-success {
      padding-top: $content-padding * 2;
      padding-bottom: $content-padding * 2;
      border-color: #a2d8ae;
    }

    .alert-warning {
      border-color: $color-warning-border;
      background-color: $color-warning;
    }

    .detail {
      display: flex;

      .detail-icon {
        flex: 0 0 4.8rem;
        height: 4.8rem;
        background-position: center top;
        background-size: contain;
        background-repeat: no-repeat;

        &--envelope {
          background-position-y: -7px;
        }
      }

      .detail-body {
        margin-left: 3rem;
      }
    }
    .bannerTitle {
      position: absolute;
      transform: none;
      bottom: 0;
      top: auto;
      h1 {
        font-size: 40px;
      }
    }
  }
}
@include desktop {
  #app {
    .ConfirmationView {
      .ApplicationBanner {
        h1 {
          font-size: 40px;
        }
        .bgLeftElement {
          left: -344px;
          bottom: -282px;
        }
        .bgRightElement {
          right: -210px;
          bottom: -110px;
        }
      }
    }
  }
}
@include tablet-wide {
  #app {
    .ConfirmationView {
      .ApplicationBanner {
        h1 {
          font-size: 40px;
        }
        .bgLeftElement {
          left: -344px;
          bottom: -282px;
        }
      }
    }
  }
}
@include mobile {
  #app {
    .ConfirmationView {
      .ApplicationBanner {
        height: 68px;
        max-height: 68px;
        .headline {
          .bannerTitle {
            left: 0;
            h1 {
              padding: 0 15px;
            }
          }
          .bgLeftElement {
            height: 130px;
            left: -115px;
            bottom: -80px;
          }
          .bgRightElement {
            height: 90px;
            right: -400px;
            bottom: -38px;
          }
        }
      }
    }
  }
}
</style>
